var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0H5C2.243 0 0 2.243 0 5V15C0 17.757 2.243 20 5 20H19C21.757 20 24 17.757 24 15V5C24 2.243 21.757 0 19 0ZM4 9H10C10.552 9 11 9.448 11 10C11 10.552 10.552 11 10 11H4C3.448 11 3 10.552 3 10C3 9.448 3.448 9 4 9ZM20 15H4C3.448 15 3 14.552 3 14C3 13.448 3.448 13 4 13H20C20.552 13 21 13.448 21 14C21 14.552 20.552 15 20 15ZM21 9C21 10.103 20.103 11 19 11H15C13.897 11 13 10.103 13 9V7C13 5.897 13.897 5 15 5H19C20.103 5 21 5.897 21 7V9ZM19 7V9H15V7H19Z",
    fill: "#2F4858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSubscription);
export default __webpack_public_path__ + "static/media/menu_subscription.c48af769d015dac6db8d4707412da999.svg";
export { ForwardRef as ReactComponent };